export enum WebsiteSliderTypeEnum {
  Homepage = 'homepage',
  RecommendationsHome = 'recommendationsHome',
  RecommendationsContact = 'recommendationsContact',
  RecommendationsArtists = 'recommendationsArtists',
  RecommendationsCollectors = 'recommendationsCollectors',
}
